import { render, staticRenderFns } from "./q-head.vue?vue&type=template&id=05546508&"
import script from "./q-head.vue?vue&type=script&lang=js&"
export * from "./q-head.vue?vue&type=script&lang=js&"
import style0 from "./q-head.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports